import { render, staticRenderFns } from "./italktocol.vue?vue&type=template&id=528400ec&scoped=true&"
import script from "./italktocol.vue?vue&type=script&lang=js&"
export * from "./italktocol.vue?vue&type=script&lang=js&"
import style0 from "./italktocol.vue?vue&type=style&index=0&id=528400ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528400ec",
  null
  
)

export default component.exports